import { render, staticRenderFns } from "./PageAdminModules.vue?vue&type=template&id=444b4a56"
import script from "./PageAdminModules.vue?vue&type=script&lang=js"
export * from "./PageAdminModules.vue?vue&type=script&lang=js"
import style0 from "./PageAdminModules.vue?vue&type=style&index=0&id=444b4a56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports